var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 50,
    viewBox: "0 0 37 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5265 41.7339L14.1474 44.1395L0 7.41031H9.8804L16.9889 26.1382L20.3631 35.1388L22.0503 39.6392L22.5265 41.7339Z",
    fill: "url(#paint0_linear_514_9853)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.563 13.9328V21.8922H11.3702V13.8198C11.0958 13.8198 10.8213 13.8683 10.563 13.9328Z",
    fill: "url(#paint1_linear_514_9853)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35107 16.8389V21.9083H10.5629V13.9328C9.28746 14.288 8.35107 15.4504 8.35107 16.8389Z",
    fill: "url(#paint2_linear_514_9853)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8407 11.3497C14.5662 11.3497 14.2918 11.3981 14.0334 11.4627V21.9083H14.8407V11.3497Z",
    fill: "url(#paint3_linear_514_9853)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8215 14.3687V21.9083H14.0334V11.4627C12.7579 11.8179 11.8215 12.9803 11.8215 14.3687Z",
    fill: "url(#paint4_linear_514_9853)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4897 8.24991V21.9083H18.297V8.1369C18.0064 8.1369 17.7481 8.18534 17.4897 8.24991Z",
    fill: "url(#paint5_linear_514_9853)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2778 11.1559V21.9083H17.4897V8.24991C16.2142 8.60509 15.2778 9.76751 15.2778 11.1559Z",
    fill: "url(#paint6_linear_514_9853)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5564 20.9235C36.5242 19.2444 36.2013 17.5815 35.7815 15.9348C35.5555 15.0791 35.281 14.2234 35.0066 13.3032C34.829 14.6109 34.7644 15.8702 34.4899 17.0649C34.4899 17.0972 34.4738 17.1295 34.4738 17.1618C33.6827 20.5844 31.5677 23.1999 29.0169 25.4763C26.7889 27.4621 24.448 29.351 22.2361 31.3368C19.54 33.7585 17.3604 36.5515 16.1496 40.0226C16.1335 40.0872 16.0527 40.1356 15.9397 40.2486C16.0366 38.7795 16.3918 37.4556 16.9568 36.1963C18.1354 33.5809 19.992 31.4659 21.9617 29.4317C23.8345 27.4943 25.7718 25.6054 27.58 23.6035C28.5003 22.5864 29.3075 21.4401 30.034 20.2615C32.0682 16.9519 32.2781 13.4485 30.9381 9.83209C30.147 7.68486 29.0169 5.7475 27.7092 3.95544C26.6921 2.58314 25.5781 1.27543 24.448 0C24.9646 2.38941 25.5781 4.79496 25.9978 7.2328C27.015 13.3032 25.4489 18.6309 21.2352 23.1676C19.9759 24.5237 18.765 25.9122 17.5219 27.2845C13.4534 31.7888 12.3395 37.0681 13.5019 42.8963C13.9539 45.1889 14.2768 47.2877 15.1971 49.7094C15.2132 49.7578 15.2455 49.8224 15.3101 50C15.7298 48.9667 16.1819 47.659 16.6339 46.5773C16.6985 46.432 16.747 46.3029 16.8115 46.1576C18.7327 41.8631 21.7679 38.4566 25.4651 35.6151C27.467 34.0814 29.5174 32.5961 31.5032 31.03C33.9572 29.0765 35.8461 26.7033 36.3789 23.5066C36.5403 22.6348 36.5887 21.7791 36.5564 20.9235Z",
    fill: "url(#paint7_linear_514_9853)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0209 28.8828C32.9886 27.6719 32.7303 26.4772 32.3751 25.2987C32.1814 24.6852 31.9554 24.0717 31.7455 23.4097C31.6002 24.3623 31.5356 25.2502 31.3096 26.122C31.3096 26.1382 31.2934 26.1705 31.2934 26.1866C30.6315 28.6568 28.8879 30.5295 26.7568 32.1763C24.9001 33.6132 22.9789 34.9532 21.1223 36.4062C18.8943 38.1498 17.07 40.1518 16.069 42.6542C16.0529 42.7026 15.9883 42.7349 15.9076 42.8156C15.9883 41.7501 16.2789 40.8137 16.7471 39.9096C17.7158 38.0207 19.2657 36.5031 20.8963 35.0339C22.4462 33.6293 24.0606 32.2732 25.5621 30.8363C26.337 30.1098 26.999 29.2703 27.5963 28.4307C29.2753 26.0575 29.4529 23.5228 28.3551 20.9235C27.6932 19.3736 26.7568 17.9851 25.6751 16.6936C24.8356 15.6926 23.9153 14.7562 22.9628 13.836C23.3987 15.5634 23.8992 17.2909 24.2382 19.0345C25.0777 23.4097 23.7862 27.2522 20.2828 30.5134C19.2334 31.4821 18.2324 32.483 17.1991 33.484C13.8088 36.7291 12.8885 40.5231 13.8572 44.7207C14.2447 46.3674 14.503 47.885 15.2779 49.6287C15.2941 49.661 15.3102 49.7094 15.3748 49.8385C15.7138 49.0959 16.1013 48.1595 16.4726 47.3846C16.5211 47.2877 16.5695 47.1747 16.6179 47.0778C18.2163 43.978 20.7348 41.5402 23.8023 39.4898C25.4652 38.3758 27.1765 37.3103 28.8072 36.1802C30.8414 34.7756 32.4074 33.0642 32.8595 30.7556C33.0048 30.1098 33.0371 29.4963 33.0209 28.8828Z",
    fill: "url(#paint8_linear_514_9853)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M3.10473 24.2008C2.68497 24.5076 2.36207 24.9596 2.10376 25.5086C6.33366 25.896 8.36789 28.6891 9.77247 32.1763C10.2084 33.2418 10.5313 34.372 10.9672 35.6635C11.0802 34.937 11.2578 34.2267 11.4515 33.5647C11.1286 32.5799 10.8542 31.692 10.5151 30.8363C9.15897 27.4298 7.17318 24.6852 3.10473 24.2008Z",
    fill: "url(#paint9_linear_514_9853)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3453 22.4088C15.084 22.4088 11.839 22.4249 8.57774 22.4088C7.9481 22.4088 7.46376 22.5702 7.06015 23.0869C6.91484 23.2644 6.57581 23.3129 6.31749 23.3613C5.51026 23.5228 4.68688 23.5712 3.91194 23.8134C3.62133 23.9102 3.36302 24.0394 3.12085 24.217C7.1893 24.6852 9.15895 27.4459 10.5312 30.8524C10.8703 31.7081 11.1447 32.5961 11.4676 33.5809C11.9197 32.1279 12.5493 30.7879 13.3081 29.5447C14.6481 26.897 16.5855 24.6529 18.652 22.4411C18.539 22.4088 18.4421 22.4088 18.3453 22.4088Z",
    fill: "url(#paint10_linear_514_9853)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9848 34.9209C29.9525 34.0491 29.7426 33.1934 29.452 32.3377C29.2906 31.8857 29.113 31.4498 28.9192 30.9816C28.8062 31.6596 28.7416 32.3054 28.564 32.9351C28.564 32.9512 28.5479 32.9674 28.5479 32.9835C27.999 34.7594 26.546 36.1156 24.7862 37.2941C23.2525 38.3274 21.638 39.2961 20.1042 40.3293C18.2476 41.5886 16.7462 43.0255 15.9066 44.8337C15.8905 44.866 15.8421 44.8821 15.7613 44.9628C15.8259 44.204 16.0681 43.526 16.4556 42.864C17.2628 41.5079 18.5382 40.41 19.8944 39.3606C21.1859 38.3597 22.5098 37.3749 23.7691 36.3416C24.4149 35.8088 24.9638 35.2115 25.4643 34.6141C26.8689 32.9028 27.0142 31.0784 26.0939 29.2057C25.545 28.0917 24.77 27.0907 23.8659 26.1543C23.1717 25.4278 22.3968 24.7497 21.6218 24.0878C21.977 25.3309 22.3968 26.5741 22.6874 27.8334C23.3816 30.9816 22.3161 33.7423 19.41 36.0994C18.5382 36.7936 17.7148 37.5202 16.8592 38.2305C14.05 40.5553 13.2912 43.2999 14.0984 46.319C14.4213 47.5137 14.6312 48.5954 15.277 49.8547C15.2931 49.887 15.3093 49.9193 15.3577 50C15.6483 49.4672 15.9551 48.7891 16.2618 48.2241C16.3102 48.1433 16.3425 48.0788 16.391 48.0142C17.7148 45.7862 19.8136 44.0265 22.3483 42.5573C23.7368 41.7662 25.1414 40.9913 26.4975 40.184C28.1927 39.1669 29.4843 37.9399 29.8556 36.277C29.9686 35.8088 30.0009 35.3729 29.9848 34.9209Z",
    fill: "url(#paint11_linear_514_9853)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4667 39.1508C27.4505 38.5211 27.2568 37.9076 27.0146 37.2941C26.8854 36.9712 26.724 36.6484 26.5787 36.3093C26.4818 36.7937 26.4334 37.2618 26.2881 37.7139C26.2881 37.73 26.2719 37.73 26.2719 37.7462C25.8199 39.0216 24.609 40.0064 23.156 40.846C21.8806 41.5886 20.5406 42.2828 19.2813 43.0416C17.7476 43.9457 16.4883 44.979 15.7941 46.2867C15.7779 46.3029 15.7456 46.319 15.6811 46.3674C15.7295 45.8185 15.9394 45.3342 16.2623 44.8498C16.9403 43.865 17.9897 43.0901 19.1199 42.3313C20.1854 41.6048 21.2994 40.9105 22.3327 40.1517C22.8654 39.7804 23.3175 39.3445 23.7372 38.9086C24.8997 37.6816 25.0127 36.3739 24.2539 35.0177C23.8018 34.2105 23.156 33.5001 22.4134 32.8221C21.8322 32.3054 21.2025 31.8211 20.5406 31.3368C20.8312 32.2247 21.1864 33.1288 21.4285 34.0329C22.0098 36.2932 21.1218 38.2951 18.7162 39.9742C17.9897 40.4746 17.2955 40.9913 16.6013 41.5079C14.2765 43.1869 13.6307 45.1566 14.3088 47.3361C14.5671 48.1918 14.7447 48.9829 15.2774 49.887C15.2936 49.9031 15.3097 49.9354 15.342 50C15.5842 49.6125 15.8425 49.1282 16.1008 48.7246C16.1331 48.6761 16.1654 48.6115 16.1977 48.5631C17.2955 46.9648 19.0391 45.6894 21.1541 44.6238C22.3004 44.0426 23.4789 43.4937 24.609 42.9125C26.0136 42.186 27.0953 41.298 27.4021 40.1033C27.4505 39.7804 27.4828 39.4575 27.4667 39.1508Z",
    fill: "url(#paint12_linear_514_9853)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_514_9853",
    x1: 11.588,
    y1: 8.13692,
    x2: 11.588,
    y2: 44.1395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1DEF1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_514_9853",
    x1: 10.9666,
    y1: 13.8198,
    x2: 10.9666,
    y2: 21.8922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5285CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4C5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_514_9853",
    x1: 9.45698,
    y1: 13.9328,
    x2: 9.45698,
    y2: 21.9083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#195BBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#184B98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_514_9853",
    x1: 14.4371,
    y1: 11.3497,
    x2: 14.4371,
    y2: 21.9083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5285CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4C5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_514_9853",
    x1: 12.9274,
    y1: 11.4627,
    x2: 12.9274,
    y2: 21.9083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#195BBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#184B98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_514_9853",
    x1: 17.8934,
    y1: 8.1369,
    x2: 17.8934,
    y2: 21.9083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5285CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4C5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_514_9853",
    x1: 16.3837,
    y1: 8.24991,
    x2: 16.3837,
    y2: 21.9083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#195BBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#184B98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_514_9853",
    x1: 27.6918,
    y1: -4.16373e-7,
    x2: 14.4313,
    y2: 49.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3174E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#193E65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_514_9853",
    x1: 23.2593,
    y1: 13.836,
    x2: 23.2593,
    y2: 49.8385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0045B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_514_9853",
    x1: 2.21053,
    y1: 23.5309,
    x2: 11.5709,
    y2: 36.6615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#477CC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8D5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_514_9853",
    x1: 10.8864,
    y1: 22.4088,
    x2: 10.8864,
    y2: 33.5809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6FD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#134389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_514_9853",
    x1: 21.8914,
    y1: 24.0878,
    x2: 21.8914,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF7900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_514_9853",
    x1: 20.7624,
    y1: 31.3368,
    x2: 20.7624,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEDCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB9200"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a73e7895dd7090c1af642e6f0e6856f6.svg";
export { ForwardRef as ReactComponent };